import {Manage} from "@/Pages/Manage/Manage";
import i18n from "i18next";
import {Card} from "@/Components/Card";
import Authenticated from "@/Layouts/Authenticated";
import "@/../sass/authenticated/billing.scss";
import React, {useReducer} from "react";
import EditPaymentDetailsModal from "@/Pages/Manage/EditPaymentDetailsModal";
import {Link, usePage} from '@inertiajs/inertia-react';
import styles from "../../../sass/components/Invoices.module.scss";

function reducer(state, action) {
    switch(action.type) {
        case "editPaymentDetailsModal":
            return { ...state, editPaymentDetailsModal: action.payload.editPaymentDetailsModal }
        default:
            return state;
    }
}

export default function Billing() {

    const [state, dispatch] = useReducer(reducer, {
        editPaymentDetailsModal: false,
        pbEnv: usePage().props.pbEnv
    });

    let billingInfo = usePage().props['token-data'];
    const paymentApiKey = usePage().props.paymentsApiKey;

    const canAccessRequestToInvoice = usePage().props.auth.user.can.access_request_invoice;
    const canAccessPaymentDetails = usePage().props.auth.user.isOwner;
    const canEditPaymentDetails = !usePage().props.auth.user.isImpersonating

    return (
        <div>
            <Manage className="admin-subscriptions" title={i18n.t('billing.billing')}>
                <div className="row">
                    <Card className="overview-card col">
                        <div className="overview-header">
                            <span className="card-title">{i18n.t("billing.overview")}</span>
                        </div>
                        <div className="overview-body">
                            <div className="col">
                                <div className="col-header">
                                    <i className="far fa-file-contract" />
                                    {i18n.t("billing.contract-period")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['contract-period']}
                                </div>
                            </div>
                            <div className="col">
                                <div className="col-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"/></svg>
                                    {i18n.t("billing.renewal-date")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['renewal-date']}
                                </div>
                            </div>
                            <div className="col">
                                <div className="col-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
                                    {i18n.t("billing.next-charge-date")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['next-charge-date']}
                                </div>
                            </div>
                            <div className="col">
                                <div className="col-header">
                                    <i className="far fa-usd-square"/>
                                    {i18n.t("billing.next-charge-amount")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['next-charge-amount']}
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
                { canAccessPaymentDetails &&
                <div className="row">
                    <Card className="payment-details-card col">
                        <div className="payment-details-header">
                            <span className="card-title">{i18n.t("billing.payment-details")}</span>
                            { canEditPaymentDetails &&
                                <span onClick={() => dispatch({ type: "editPaymentDetailsModal", payload: { editPaymentDetailsModal: true }})}
                                    className="card-action">{i18n.t("billing.edit-payment-details")}</span>
                            }
                        </div>
                        <div className="payment-details-body">
                            <div className="col">
                                <div className="col-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"/></svg>
                                    {i18n.t("billing.billing-owner")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['billing-owner']}
                                </div>
                            </div>
                            <div className="col">
                                <div className="col-header">
                                    {billingInfo['show-card'] && <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><path d="M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"/></svg>}
                                    {billingInfo['show-bank'] && <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><path fill="currentColor" d="M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg>}
                                    {i18n.t("billing.payment-method")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['payment-method']}:  {billingInfo['last-four']}
                                </div>
                            </div>
                            <div className="col">
                                <div className="col-header">
                                    <i className="fal fa-map-marker-alt"></i>
                                    {i18n.t("billing.organization-address")}
                                </div>
                                <div className="col-body">
                                    <div>{billingInfo['billing-address']['line-1']}{billingInfo['billing-address']['line-2'] ? ", " + billingInfo['billing-address']['line-2'] : ""}</div>
                                    <div>{billingInfo['billing-address']['city']}, {billingInfo['billing-address']['state']} {billingInfo['billing-address']['postal-code']} </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="col-header">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512"><path d="M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"/></svg>
                                    {i18n.t("billing.organization-name")}
                                </div>
                                <div className="col-body">
                                    {billingInfo['organization-name']}
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
                }
                { canAccessRequestToInvoice &&
                    <div className="row">
                        <Card className="invoices-card col">
                            <div className="invoices-header">
                                <span className="card-title">{i18n.t("billing.invoices")}</span>
                                <span className="card-action"
                                      onClick={() => window.open('https://help.myamplify.io/hc/en-us/requests/new', '_blank')}>
                                {i18n.t("billing.request-an-invoice")}
                            </span>
                            </div>
                            <div className="invoices-svg-container">
                                <img src="/images/invoices.svg"/>
                            </div>
                        </Card>
                        <Card className="usage-card col">
                            <div className="usage-header">
                                <span className="card-title">{i18n.t("billing.usage")}</span>
                                <Link href={route('manage.usage-show')} className={styles.requestInvoice + " no-link"}>
                                    <span className="card-action">
                                        {i18n.t("billing.view")}
                                    </span>
                                </Link>
                            </div>

                            <span>
                                <Link href={route('manage.usage-show')} className={styles.requestInvoice + " no-link"}>
                                    <img src="/images/usage.svg"/>
                                </Link>
                            </span>
                        </Card>
                    </div>
                }
            </Manage>
            {state.editPaymentDetailsModal &&
                <EditPaymentDetailsModal
                    state={state}
                    dispatch={dispatch}
                    apiKey={paymentApiKey}
                />
            }
        </div>
    )
}

Billing.layout = page => <Authenticated children={page}></Authenticated>
